import { compose } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'modules/shared/redux/utils/type';
import { authenticationModule, AuthenticationState } from 'modules/shared/redux';
import { WithQuerystringReading } from 'modules/shared/hocs';

import { LoginStateProps, LoginDispatchProps, LoginOwnProps } from './login-type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (states: any): LoginStateProps => {
    const subState = states[authenticationModule.storeName] as AuthenticationState;
    let errorMessage: string | undefined;
    if (!!subState.error && !!subState.error.subCode) {
        if (subState.error.subCode === 32) {
            errorMessage = 'Identifiants incorrects';
        } else if (subState.error.subCode === 24.1) {
            errorMessage = 'Votre dossier est fermé';
        }
    }

    return {
        isAuthenticated: !!subState.token && subState.token.isValid(),
        errorMessage,
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): LoginDispatchProps => ({
    login: (folderIdOrEmail: string, password: string) =>
        dispatch(authenticationModule.action.login(folderIdOrEmail, password)),
});

const enhancer = compose<React.ComponentType<LoginOwnProps>>(
    connect<LoginStateProps, LoginDispatchProps, LoginOwnProps>(mapStateToProps, mapDispatchToProps),
    WithQuerystringReading<{ token: string }>(),
);
export default enhancer;
